import { render, staticRenderFns } from "./SetupProfileTab.vue?vue&type=template&id=1ca77c05&scoped=true&"
import script from "./SetupProfileTab.vue?vue&type=script&lang=js&"
export * from "./SetupProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./SetupProfileTab.vue?vue&type=style&index=0&id=1ca77c05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca77c05",
  null
  
)

component.options.__file = "SetupProfileTab.vue"
export default component.exports